import React from 'react';
import { useGame } from '../contexts/GameContext';
import { useAuth } from '../contexts/AuthContext';
import { TrophyIcon, ClockIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

function DailyChallenges() {
  const { dailyChallenges, updateDailyChallengeProgress } = useGame();
  const { user } = useAuth();

  const handleCompleteChallenge = (challengeId) => {
    updateDailyChallengeProgress(challengeId, 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f56756] to-[#402e2c] p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white">Daily Challenges</h1>
          <div className="flex items-center gap-2 text-[#402e2c]">
            <ClockIcon className="h-5 w-5" />
            <span>Resets in 24h</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {dailyChallenges.map((challenge) => (
            <div
              key={challenge.id}
              className="bg-[#b34e42]/80 backdrop-blur-sm rounded-2xl p-6 border border-[#402e2c]/20"
            >
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {challenge.title}
                  </h3>
                  <p className="text-gray-400 mb-4">{challenge.description}</p>
                </div>
                <div className="bg-[#402e2c]/20 rounded-full p-2">
                  <TrophyIcon className="h-6 w-6 text-[#402e2c]" />
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">Progress</span>
                  <span className="text-[#402e2c]">
                    {challenge.progress}/{challenge.target}
                  </span>
                </div>

                <div className="w-full bg-[#402e2c]/20 rounded-full h-2">
                  <div
                    className="bg-[#402e2c] h-2 rounded-full transition-all duration-300"
                    style={{
                      width: `${(challenge.progress / challenge.target) * 100}%`
                    }}
                  />
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <CheckCircleIcon className="h-5 w-5 text-[#402e2c]" />
                    <span className="text-[#402e2c]">{challenge.reward} coins</span>
                  </div>
                  <button
                    onClick={() => handleCompleteChallenge(challenge.id)}
                    disabled={challenge.progress >= challenge.target}
                    className={`px-4 py-2 rounded-full text-sm font-medium ${
                      challenge.progress >= challenge.target
                        ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                        : 'bg-[#402e2c] text-white hover:bg-[#402e2c]/80'
                    }`}
                  >
                    {challenge.progress >= challenge.target ? 'Completed' : 'Complete'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DailyChallenges; 